export const getImageUrl = (url: string) => {
  return `https://spack-resource.nhuahvt.com/${url}`;
};

export const linkProduct = (pSlug?: string, id?: string | number) => {
  return `/san-pham/${pSlug}`;
};
